import { CustomHttpError } from "./customHttpError";

export function throwIfNotSuccess(response: Response) {
    if (response.status === 200) {
        return;
    }

    throw new CustomHttpError(response.status, response.statusText);
}
